<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
    <div class="vx-row mb-2">
      <div class="vx-col md:w-1/4 w-full">
          <vs-input class="w-full" :placeholder="$t('Labels.DevEui')" v-model="filter.deveui"/>
      </div>
      <div class="vx-col md:w-1/4 w-full">
          <vs-input class="w-full" :placeholder="$t('Labels.Serie')" v-model="filter.serie"/>
      </div>
      <div class="vx-col md:w-1/4 w-full">
          <vs-input class="w-full" :placeholder="$t('Labels.DevAddress')" v-model="filter.dev_address"/>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-button @click="getResponse()" radius color="primary" type="filled" icon="search"></vs-button>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full">
          <label>{{$tc('Labels.App',1)}}</label>
          <v-select :options="apps" v-model="filter.app_id" :reduce="org => org.id_nw" label="name"/>
      </div>
      <div class="vx-col md:w-1/3 w-full">
          <label>{{$t('Labels.Type')}}</label>
          <v-select :options="types" v-model="filter.device_type_uuid" :reduce="org => org.uuid" label="name"/>
      </div>
      <div class="vx-col md:w-1/3 w-full">
          <label>{{$t('Labels.Status')}}</label>
          <v-select :options="statusOptions" v-model="filter.status" :reduce="org => org.value" label="label"/>
      </div>
      
    </div>
    <vs-table v-if="response" :data="response"
      @selected="goToDetail">
      <template slot="thead">
        <vs-th sort-key="serie">
          {{$t('Labels.Serie')}}
        </vs-th>
        <vs-th sort-key="device_type.name">
          {{$t('Labels.DeviceType')}}
        </vs-th>
        <vs-th sort-key="status.name">
          {{$t('Labels.Status')}}
        </vs-th>
        <vs-th sort-key="user_creator.first_name">
          {{$t('Labels.Creator')}}
        </vs-th>
      </template>

      <template  slot-scope="{data}">
        <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
          <vs-td :data="item.serie">
            {{item.serie}}
          </vs-td>
          <vs-td :data="item.device_type != null ?item.device_type.name: ''">
            {{item.device_type != null ?item.device_type.name: ''}}
          </vs-td>
          <vs-td :data="item.status != null ?item.status.name: ''">
            {{item.status != null ?item.status.name: ''}}
          </vs-td>
          <vs-td :data="item.user_creator.first_name+' '+item.user_creator.last_name">
            {{item.user_creator.first_name+' '+item.user_creator.last_name}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import listAlertItem from '@/components/listAlertItem/listAlertItem.vue'

export default {
  components: {
    'v-select': vSelect,
    listItem,
    listAlertItem
  },
  data () {
    return {
      isMounted: false,
      response: [],
      currentx: 1,
      active:false,
      totalPages: 0,
      countRows: 0,
      oldCurrentPage: 1,
      filter:{
        devEui:'',
        serie:'',
        dev_address: '',
        status:'0',
        limit: 20,
        offset: 0,
        byColumn: 'uuid',
        byOrder: 'ASC',
        app_id: this.$route.query.app != undefined ? this.$route.query.app : '',
        device_type_uuid: this.$route.query.type != undefined ? this.$route.query.type : '',
        license_uuid: this.$route.query.license != undefined ? this.$route.query.license : ''
      },
      statusOptions: [
        {label: this.$t('Labels.All'), value: '0'},
        {label: 'Almacén', value: 'A'},
        {label: 'Cliente Activo', value: 'CA'},
        {label: 'Cliente Inactivo', value: 'CI'},
        {label: 'Soporte', value: 'S'},
        {label: 'Baja', value: 'D'}
      ],
      apps:[],
      types:[]
    }
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },


  methods: {
    async getApps () {
      this.$vs.loading()
      const params = {
        url: 'applications',
        method: 'GET',
        params:{
          limit:10000,
          offset:0,
          byColumn:'name',
          byOrder:'asc'
        }
      }
      await request(params).then(response => {
        this.apps = response.data.data.rows
        this.apps.unshift({
          id_nw:0,
          name: this.$t('Labels.All')
        })
        this.filter.app_id = 0
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    async getTypes () {
      this.$vs.loading()
      const params = {
        url: 'device_types',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.types = response.data.data
        this.types.unshift({
          uuid:0,
          name: this.$t('Labels.All')
        })
        this.filter.device_type_uuid = 0
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    async getResponse () {
      const params = {
        url: 'devices',
        method: 'GET',
        params: this.filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.countRows = response.data.data.count
      }).catch(() => {
        this.response = []
        this.totalPages = 0
        this.countRows = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    goToDetail (item) {
      window.location.href = `/devices/${item.uuid}`
    }

  },

  created () {
    /*this.$route.meta.breadcrumb[1].title = this.$t('Path.Devices')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.List')
    this.$route.meta.pageTitle = this.$t('Path.List')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})*/
    this.getApps()
    this.getTypes()
    this.getResponse()
  },

  mounted () {
    this.isMounted = true
  },

  updated () {
    if (this.oldCurrentPage != this.currentx) {
      this.oldCurrentPage = this.currentx
      this.getResponse()
    }
  },
  watch:{
    countRows (val) {
      let limit = this.filter.limit
      if (limit > val) limit = val
      let pages = val / limit
      if (val % limit > 0) pages++
      this.totalPages = pages
    }
  }
}
</script>
